import React from 'react';
import AssetWrapper, { AssetWrapperProps } from 'src/app/atoms/Asset/AssetWrapper';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { ColorModePropKeys } from 'src/app/styles/colors';
import { ImageContainer } from './ImageAndContent.styles';

export interface ImageAndContentProps {
  image: AssetWrapperProps;
  content: React.ReactNode;
  contentPosition?: 'left' | 'right';
  contentBackground?: ColorModePropKeys;
}

const ImageAndContent = ({
  image,
  content,
  contentPosition = 'right',
  contentBackground,
}: ImageAndContentProps): JSX.Element => {
  const renderImageBlock = () => (
    <ImageContainer
      columns={6}
      columnsLg={12}
      justify='center'
      align='center'
    >
      <AssetWrapper {...image} />
    </ImageContainer>
  );

  const renderContentBlock = () => (
    <Stack
      columns={6}
      columnsLg={12}
      padding={[
        'spacing-none',
        contentPosition === 'right' ? 'spacing-none' : 'spacing-7xl',
        'spacing-none',
        contentPosition === 'left' ? 'spacing-none' : 'spacing-7xl',
      ]}
      paddingLg={['spacing-none', 'spacing-none', 'spacing-4xl']}
      justify='center'
      align='center'
      background={contentBackground}
    >
      {content}
    </Stack>
  );

  const renderContentFirst = () => (
    <Grid>
      {renderContentBlock()}
      {renderImageBlock()}
    </Grid>
  );

  const renderMobile = () => (
    <Grid showOn='lg'>
      {renderContentBlock()}
      {renderImageBlock()}
    </Grid>
  );

  const renderImageFirst = () => (
    <>
      <Grid hideOn='lg'>
        {renderImageBlock()}
        {renderContentBlock()}
      </Grid>
      {renderMobile()}
    </>
  );

  return (
    <Stack
      direction='column'
      align='center'
      justify='center'
      maxWidthLg='width-md'
    >
      {contentPosition === 'left' ? renderContentFirst() : renderImageFirst()}
    </Stack>
  );
};

export default ImageAndContent;
